import {
  getValidLuxonDate,
  formatDateRange,
} from "../../../../utils/date.utils"
import { numberFormatter } from "../../../../utils/numbers.utils"
import iconFrame from "../../../../design/assests/images/icons/Frame.png"

export const buildSummarySection = async (
  doc,
  sprintData,
  y,
  sprintSummaryData,
  period
) => {
  const pageWidth = doc.internal.pageSize.getWidth()

  const sideMargin = 10
  const usableWidth = pageWidth - sideMargin * 2
  const columnWidth = usableWidth / 3

  const titleColor = "#24292F"
  const subtitleColor = "#737E8D"
  const labelColor = "#737E8D"
  const valueColor = "#24292F"

  const iconSize = 6
  const spacing = 2
  const iconOffsetY = 2

  const getPeriodLabel = (startDate, endDate) => {
    if (!startDate) return "En curso"
    if (!endDate)
      return `${getValidLuxonDate(startDate)?.setLocale("es").toFormat("dd MMM yyyy")} - En curso`
    return formatDateRange(startDate, endDate)
  }

  doc.addImage(
    iconFrame,
    "PNG",
    sideMargin,
    y - iconOffsetY,
    iconSize,
    iconSize
  )

  doc.setFont("Cairo-SemiBold", "normal")
  doc.setFontSize(9)
  doc.setTextColor(titleColor)

  doc.text(
    sprintSummaryData?.title || "",
    sideMargin + iconSize + spacing,
    y + 1
  )

  y += 3

  if (sprintSummaryData?.subtitle) {
    doc.setFont("Mulish-Regular", "normal")
    doc.setFontSize(7)
    doc.setTextColor(titleColor)

    doc.text(sprintSummaryData.subtitle, sideMargin + iconSize + spacing, y + 1)

    y += 7
  } else {
    y += 5
  }

  doc.setFont("Mulish-Bold", "normal")
  doc.setFontSize(7.5)
  doc.setTextColor(labelColor)

  doc.text("Fecha de periodo", sideMargin, y)
  doc.text("Consumo del periodo", sideMargin + columnWidth, y)
  doc.text("Avance del periodo", sideMargin + columnWidth * 2, y)

  y += 6

  doc.setFont("Cairo-SemiBold", "normal")
  doc.setFontSize(12)
  doc.setTextColor(valueColor)

  doc.text(
    getPeriodLabel(sprintSummaryData?.startDate, sprintSummaryData?.endDate),
    sideMargin,
    y
  )

  const consumption = numberFormatter(sprintSummaryData.periodConsumption, 1)

  const consumptionX = sideMargin + columnWidth

  doc.setFont("Cairo-SemiBold", "normal")
  doc.setFontSize(12)

  const consumptionWidth = doc.getTextWidth(consumption)

  doc.text(consumption, consumptionX, y)

  doc.setFont("Cairo-SemiBold", "normal")
  doc.setFontSize(9)

  doc.text("horas", consumptionX + consumptionWidth + 1, y)

  const value = numberFormatter(sprintSummaryData.periodPoints, 0)
  const x = sideMargin + columnWidth * 2

  doc.setFont("Cairo-SemiBold", "normal")
  doc.setFontSize(12)

  const valueWidth = doc.getTextWidth(value)

  doc.text(value, x, y)

  doc.setFont("Cairo-SemiBold", "normal")
  doc.setFontSize(9)

  doc.text("pts dev", x + valueWidth + 1, y)

  y += 8

  doc.setDrawColor(204, 212, 222)
  doc.setLineWidth(0.3)
  doc.line(sideMargin, y, pageWidth - sideMargin, y)

  return y + 10
}
